import { Component, h, Host, Element, Event, EventEmitter, Listen } from '@stencil/core';
import { AhaEzTab } from '../aha-ez-tab/aha-ez-tab';

export interface AhaEzTabs extends HTMLAhaEzTabsElement {}

@Component({
  tag: 'aha-ez-tabs',
  styleUrl: 'aha-ez-tabs.css',
  shadow: true,
})
export class AhaEzTabs {
  @Element() host!: HTMLAhaEzTabsElement;

  @Listen('tabSelected')
  handleTabSelected(event: CustomEvent) {
    const tab = event.target as HTMLAhaEzTabElement;
    const ezTabsElem = tab.closest('aha-ez-tabs');

    // Only emit this event if the tab is a child of the aha-ez-tabs element and not of a nested tabs component.
    if (tab instanceof AhaEzTab && ezTabsElem === this.host) {
      // When a tab is selected, then emit an event on the aha-ez-tabs element to say that the selected value of the tabs element has changed.
      this.selectedEvent.emit({
        tab,
        panel: tab.panel,
        index: this.selectedTabIndex,
      });
    }
  }

  @Event({
    eventName: 'selected',
    cancelable: true,
    bubbles: true,
  }) //eslint-disable-line @stencil/decorators-style
  selectedEvent!: EventEmitter;

  get tabs() {
    return Array.from(
      this.host.querySelectorAll<HTMLAhaEzTabElement>(':scope > aha-ez-tab-list aha-ez-tab'),
    );
  }

  get panels() {
    return Array.from(
      this.host.querySelectorAll<HTMLAhaEzTabPanelElement>(':scope > aha-ez-tab-panel'),
    );
  }

  get selectedTab() {
    return this.host.querySelector<HTMLAhaEzTabElement>(
      ':scope > aha-ez-tab-list aha-ez-tab[aria-selected="true"]',
    );
  }

  get selectedPanel() {
    return this.host.querySelector<HTMLAhaEzTabPanelElement>(
      ':scope > aha-ez-tab-panel[aria-hidden="false"]',
    );
  }

  get selectedTabIndex() {
    const selectedTab = this.selectedTab;
    if (!selectedTab) return -1;
    const tabs = Array.from(
      this.host.querySelectorAll<HTMLAhaEzTabElement>(':scope > aha-ez-tab-list aha-ez-tab'),
    );
    return tabs.indexOf(selectedTab);
  }

  render() {
    return (
      <Host>
        <div id="layout">
          <slot name="tablist"></slot>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
